import { render } from "./ClientInvoiceList.vue?vue&type=template&id=4c9a9af4&scoped=true"
import script from "./ClientInvoiceList.vue?vue&type=script&lang=js"
export * from "./ClientInvoiceList.vue?vue&type=script&lang=js"

import "./ClientInvoiceList.vue?vue&type=style&index=0&id=4c9a9af4&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c9a9af4"]])

export default __exports__